import getStore from '../store/store';
import { incrementSearchNumber } from '../actions/searchStoreActions';
import { mutator } from 'satcheljs';

export let incrementSearchNumberMutator = mutator(incrementSearchNumber, actionMessage => {
    let searchStore = getStore();
    searchStore.searchNumber++;
});
